import { useGetSecurityEventsTableColumns } from "./hooks/useGetSecurityEventsTableColumns";
import { useGetSecurityEventsTableRows } from "./hooks/useGetSecurityEventsTableRows";
import SecurityEventsTableServer from "./SecurityEventsTableServer";

const SecurityEventsServerTableContainer = (): JSX.Element => {
  const { columns } = useGetSecurityEventsTableColumns();

  const {
    rows,
    loading,
    paginationModel,
    handlePaginationModelChange,
    hasNextPage,
    isActivePageChange,
  } = useGetSecurityEventsTableRows();

  return (
    <SecurityEventsTableServer
      columns={columns}
      rows={rows}
      loading={loading}
      onPaginationModelChange={handlePaginationModelChange}
      hasNextPage={hasNextPage}
      isActivePageChange={isActivePageChange}
      paginationModel={paginationModel}
    />
  );
};

export default SecurityEventsServerTableContainer;
